import {
  INSERT_THUMB_TYPE_BLANK,
  INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  INSERT_THUMB_TYPE_VISE_PRO_V2,
  INSERT_THUMB_TYPE_VISE_IT,
  INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
} from './idx_data_thumb_insert_types';

export const idx_data_thumb_insert_sizes = [];

let order = 0;
let i = 0;
let d = 1;

// INSERT_THUMB_TYPE_BLANK
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_BLANK,
  size: '---',
  od: '',
  order_idx: -1,
});

for (let j = 0; j <= 1; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = '';
  }

  if (i == 1) {
    d = 0;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: i + '',
      od: i + '',
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 1/64').trim(),
      od: (i + ' 1/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 1/32').trim(),
      od: (i + ' 1/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 3/64').trim(),
      od: (i + ' 3/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 1/16').trim(),
      od: (i + ' 1/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 5/64').trim(),
      od: (i + ' 5/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 3/32').trim(),
      od: (i + ' 3/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 7/64').trim(),
      od: (i + ' 7/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 1/8').trim(),
      od: (i + ' 1/8').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 9/64').trim(),
      od: (i + ' 9/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 5/32').trim(),
      od: (i + ' 5/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 11/64').trim(),
      od: (i + ' 11/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 3/16').trim(),
      od: (i + ' 3/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 13/64').trim(),
      od: (i + ' 13/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 7/32').trim(),
      od: (i + ' 7/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 15/64').trim(),
      od: (i + ' 15/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 1/4').trim(),
      od: (i + ' 1/4').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 17/64').trim(),
      od: (i + ' 17/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 9/32').trim(),
      od: (i + ' 9/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 19/64').trim(),
      od: (i + ' 19/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 5/16').trim(),
      od: (i + ' 5/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 21/64').trim(),
      od: (i + ' 21/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 11/32').trim(),
      od: (i + ' 11/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 23/64').trim(),
      od: (i + ' 23/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 3/8').trim(),
      od: (i + ' 3/8').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 25/32').trim(),
      od: (i + ' 25/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 13/32').trim(),
      od: (i + ' 13/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 27/64').trim(),
      od: (i + ' 27/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 7/16').trim(),
      od: (i + ' 7/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 29/64').trim(),
      od: (i + ' 29/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 15/32').trim(),
      od: (i + ' 15/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 31/64').trim(),
      od: (i + ' 31/64').trim(),
      order_idx: order,
    });
    order++;
    d++;
  }

  d = 32;
  idx_data_thumb_insert_sizes.push({
    type_id: INSERT_THUMB_TYPE_BLANK,
    size: (i + ' 1/2').trim(),
    od: (i + ' 1/2').trim(),
    order_idx: order,
  });
  order++;
  d++;

  if (i == 0) {
    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 33/64').trim(),
      od: (i + ' 33/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 17/32').trim(),
      od: (i + ' 17/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 35/64').trim(),
      od: (i + ' 35/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 9/16').trim(),
      od: (i + ' 9/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 37/64').trim(),
      od: (i + ' 37/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 19/32').trim(),
      od: (i + ' 19/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 39/64').trim(),
      od: (i + ' 39/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 5/8').trim(),
      od: (i + ' 5/8').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 41/64').trim(),
      od: (i + ' 41/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 21/32').trim(),
      od: (i + ' 21/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 43/64').trim(),
      od: (i + ' 43/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 11/16').trim(),
      od: (i + ' 11/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 45/64').trim(),
      od: (i + ' 45/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 23/32').trim(),
      od: (i + ' 23/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 47/64').trim(),
      od: (i + ' 47/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 3/4').trim(),
      od: (i + ' 3/4').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 49/64').trim(),
      od: (i + ' 49/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 25/32').trim(),
      od: (i + ' 25/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 51/64').trim(),
      od: (i + ' 51/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 13/16').trim(),
      od: (i + ' 13/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 53/64').trim(),
      od: (i + ' 53/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 27/32').trim(),
      od: (i + ' 27/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 55/64').trim(),
      od: (i + ' 55/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 7/8').trim(),
      od: (i + ' 7/8').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 57/64').trim(),
      od: (i + ' 57/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 29/32').trim(),
      od: (i + ' 29/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 59/64').trim(),
      od: (i + ' 59/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 15/16').trim(),
      od: (i + ' 15/16').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 61/64').trim(),
      od: (i + ' 61/64').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 31/32').trim(),
      od: (i + ' 31/32').trim(),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_thumb_insert_sizes.push({
      type_id: INSERT_THUMB_TYPE_BLANK,
      size: (i + ' 63/64').trim(),
      od: (i + ' 63/64').trim(),
      order_idx: order,
    });
    order++;
    d++;
  }
}

// INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  size: '1 1/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  size: '1 1/4',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  size: '1 3/8',
  od: '1 3/8',
});

// INSERT_THUMB_TYPE_TURBO_XCEL_SOLID
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  size: '1 1/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  size: '1 1/4',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  size: '1 3/8',
  od: '1 3/8',
});

// INSERT_THUMB_TYPE_TURBO_XCEL_ROUND
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '51/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '13/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '53/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '27/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '55/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '7/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '57/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '29/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '59/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '15/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '61/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '31/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '63/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '1',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '1 1/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '1 1/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '1 3/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  size: '1 1/16',
  od: '1 1/4',
});

// INSERT_THUMB_TYPE_TURBO_XCEL_OVAL
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '51/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '13/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '53/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '27/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '55/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '7/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '57/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '29/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '59/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '15/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '61/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '31/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '63/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '1',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '1 1/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '1 1/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '1 3/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  size: '1 1/16',
  od: '1 1/4',
});

// INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  size: '1 1/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  size: '1 1/4',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  size: '1 3/8',
  od: '1 3/8',
});

// INSERT_THUMB_TYPE_ULTIMATE_THUMB
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  size: '1 1/2',
  od: '1 1/2',
});

// INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  size: '1 1/2',
  od: '1 1/2',
});

// INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '51/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '13/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '53/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '27/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '55/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '7/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '57/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '29/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '59/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '15/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '61/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '31/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '63/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 1/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 1/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 3/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 1/16',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 5/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 3/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  size: '1 7/64',
  od: '1 1/4',
});

// INSERT_THUMB_TYPE_VISE_PRO_V2
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '51/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '13/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '53/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '27/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '55/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '7/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '57/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '29/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '59/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '15/16',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '61/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '31/32',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '63/64',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 1/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 1/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 3/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 1/16',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 5/64',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 3/32',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  size: '1 7/64',
  od: '1 1/4',
});

// INSERT_THUMB_TYPE_VISE_IT
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  size: '1 3/16',
  od: '1 3/16',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  size: '1 5/16',
  od: '1 5/16',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_IT,
  size: '1 7/16',
  od: '1 7/16',
});

// INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  size: '1 1/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  size: '1 1/4',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  size: '1 3/8',
  od: '1 3/8',
});

// INSERT_THUMB_TYPE_VISE_VINYL_SLUG
idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  size: '---',
  od: '',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  size: '1 1/8',
  od: '1 1/8',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  size: '1 1/4',
  od: '1 1/4',
});

idx_data_thumb_insert_sizes.push({
  type_id: INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  size: '1 3/8',
  od: '1 3/8',
});
